import { render } from "./StorefrontSavedPaymentMethods.vue?vue&type=template&id=48fac700&scoped=true"
import script from "./StorefrontSavedPaymentMethods.vue?vue&type=script&lang=js"
export * from "./StorefrontSavedPaymentMethods.vue?vue&type=script&lang=js"

import "./StorefrontSavedPaymentMethods.vue?vue&type=style&index=0&id=48fac700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fac700"]])

export default __exports__